
    import { defineComponent } from 'vue';
    
    export default defineComponent({
        name: 'SuccessModal',
        props: ['social_links'],

    });
